import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const AlbumDesignEditorDetail = () => {
  const [weddingAlbum, setWeddingAlbum] = useState({});
  const [status, setStatus] = useState(1);
  const [selectedEditor, setSelectedEditor] = useState("");
  const [fileLocation, setFileLocation] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  const weddingAlbumById = async () => {
    try {
      const response = await axios.get(`/wedding-album/${id}`);
      setWeddingAlbum(response.data);
      setSelectedEditor(response.data.editor || "");
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1);
    } catch (error) {
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  useEffect(() => {
    weddingAlbumById();
  }, []);

  const updateWeddingAlbum = async () => {
    try {
      await axios.put(`/album-design/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/albumdesign-editor");
    } catch (error) {
      seterrorMessage("Failed to update order");
    }
  };

  return (
    <div className="container mt-4">
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="row">
        {/* Left Panel */}
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-header fw-600">Job Details</div>
            <div className="card-body">
              <p>
                <strong>Event Name:</strong> {weddingAlbum.order_name}
              </p>
              <p>
                <strong>Service Type:</strong> {weddingAlbum.serviceId?.service}
              </p>
              <p>
                <strong>Album Type:</strong> {weddingAlbum.order_name}
              </p>
            </div>
          </div>{" "}
          <div className="card mb-3">
            <div className="card-header fw-600">Job Details</div>
            <div className="card-body">
              <p>
                <strong>Album Orientation :</strong>{" "}
                {weddingAlbum.album_orientation}
              </p>
              <p>
                <strong>Album Category :</strong> {weddingAlbum.album_category}
              </p>
              <p>
                <strong>Page Size (width x height) :</strong>{" "}
                {weddingAlbum.page_size}
              </p>
              <p>
                <strong>Album Style :</strong> {weddingAlbum.album_style}
              </p>
              <p>
                <strong>Include Logo :</strong> {weddingAlbum.include_logo}
              </p>
              <p>
                <strong>Front Cover Required :</strong>{" "}
                {weddingAlbum.front_cover}
              </p>
              <p>
                <strong>Back Cover Required :</strong> {weddingAlbum.back_cover}
              </p>
              <p>
                <strong>Background Color :</strong>{" "}
                {weddingAlbum.background_color}
              </p>
              <p>
                <strong>First page starts on :</strong>{" "}
                {weddingAlbum.first_frame}
              </p>{" "}
              <p>
                <strong>Trim Line :</strong> {weddingAlbum.trim_line}
              </p>{" "}
              <p>
                <strong>Safe Zone :</strong> {weddingAlbum.safe_zone}
              </p>{" "}
              <p>
                <strong>Name of Front Image File :</strong>{" "}
                {weddingAlbum.front_image_name}
              </p>
              <p>
                <strong>Front Cover Text - Line 1 :</strong>{" "}
                {weddingAlbum.front_cover_text_line1}
              </p>
              <p>
                <strong>Front Cover Text - Line 2 :</strong>{" "}
                {weddingAlbum.front_cover_text_line2}
              </p>
              <p>
                <strong>Name of Back Image File :</strong>{" "}
                {weddingAlbum.back_image_name}
              </p>{" "}
              <p>
                <strong>Back Cover Text - Line 1 :</strong>{" "}
                {weddingAlbum.back_cover_text_line1}
              </p>{" "}
              <p>
                <strong>Back Cover Text - Line 2 :</strong>{" "}
                {weddingAlbum.back_cover_text_line2}
              </p>{" "}
              <p>
                <strong>Cover Spine Text :</strong>{" "}
                {weddingAlbum.cover_spine_text}
              </p>{" "}
              <p>
                <strong>Font Options :</strong> {weddingAlbum.font_options}
              </p>{" "}
              <p>
                <strong>Output Format :</strong> {weddingAlbum.output_format}
              </p>
              <p>
                <strong>Quantity :</strong> {weddingAlbum.quantity}
              </p>
              <p>
                <strong>Upload:</strong> {weddingAlbum.images}
              </p>
              <p>
                <strong>Aditional notes :</strong>{" "}
                {weddingAlbum.additional_notes}
              </p>
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-header fw-600">Order Operations</div>
            <div className="card-body">
              <p>
                <strong>Client ID:</strong> {user.user.id}
              </p>
              <p>
                <strong>Order ID:</strong> {weddingAlbum.id}
              </p>
              <p>
                <strong>User Feedback:</strong> {weddingAlbum.sampleFeedback}
              </p>
              <p>
                <strong>Sample Status:</strong>{" "}
                {weddingAlbum.sampleStatus === "approved" ? (
                  <span className="btn rounded-0 btn-success btn-sm p-2 ms-2">
                    Approved
                  </span>
                ) : weddingAlbum.sampleStatus === "declined" ? (
                  <span className="btn rounded-0 btn-danger btn-sm p-2 ms-2">
                    Declined
                  </span>
                ) : (
                  <span className="text-muted ms-2">Not Selected</span>
                )}
              </p>
              <p>
                <strong>Order Place Date:</strong>{" "}
                {new Date(weddingAlbum?.createdAt).toLocaleDateString()}
              </p>
              <div>
                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>{" "}
              </div>

              <div className="mt-3">
                <label className="form-label mt-3">Editor</label>
                <input
                  type="text"
                  className="form-control"
                  value={userName}
                  readOnly
                />
              </div>

              <label className="form-label mt-3">File Location</label>
              <input
                type="text"
                className="form-control"
                value={fileLocation}
                onChange={(e) => setFileLocation(e.target.value)}
              />

              <button
                onClick={updateWeddingAlbum}
                className="btn text-light bg_maincolor mt-3"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default AlbumDesignEditorDetail;
